import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable max-lines */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { Preloader } from '../Preloader';
import { DEFAULT_CANVAS_SIZE, DEFAULT_DRAW_SETTINGS, pnpoly, polygonCoordsOperator } from './helpers';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PolygonsDrawer = /*#__PURE__*/function (_React$Component) {
  _inherits(PolygonsDrawer, _React$Component);
  var _super = _createSuper(PolygonsDrawer);
  function PolygonsDrawer(props) {
    var _this;
    _classCallCheck(this, PolygonsDrawer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "containerElement", null);
    _defineProperty(_assertThisInitialized(_this), "canvas", null);
    _defineProperty(_assertThisInitialized(_this), "ctx", void 0);
    _defineProperty(_assertThisInitialized(_this), "img", void 0);
    _defineProperty(_assertThisInitialized(_this), "resizeCtx", function () {
      var _this$state = _this.state,
        width = _this$state.width,
        height = _this$state.height;
      _this.ctx.canvas.width = width;
      _this.ctx.canvas.height = height;
    });
    _defineProperty(_assertThisInitialized(_this), "draw", function () {
      var _this$state2 = _this.state,
        width = _this$state2.width,
        height = _this$state2.height;
      var backgroundDrawingAlgorythm = _this.props.backgroundDrawingAlgorythm;
      var drawingParams = backgroundDrawingAlgorythm && backgroundDrawingAlgorythm(width, height);
      _this.resizeCtx();
      _this.drawBackground(drawingParams);
      _this.drawPolygons(drawingParams);
    });
    _defineProperty(_assertThisInitialized(_this), "drawPolygons", function (imageDrawParams) {
      var _assertThisInitialize = _assertThisInitialized(_this),
        ctx = _assertThisInitialize.ctx;
      _this.props.polygons.forEach(function (polygon) {
        var points = polygon.points;
        if (!points || points.length <= 2) {
          return;
        }
        ctx.beginPath();
        var firstPoint = polygonCoordsOperator(points[0][0], points[0][1], imageDrawParams);
        ctx.moveTo(firstPoint[1], firstPoint[0]);
        points.forEach(function (point) {
          var coords = polygonCoordsOperator(point[0], point[1], imageDrawParams);
          ctx.lineTo(coords[1], coords[0]);
        });
        ctx.closePath();
        ctx.save();
        _this.applyFillCtxSettings(ctx, polygon);
        ctx.fill();
        ctx.restore();
        if (polygon.props.strokeWidth) {
          _this.applyStrokeCtxSettings(ctx, polygon);
          ctx.stroke();
          ctx.restore();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "applyFillCtxSettings", function (ctx, polygon) {
      ctx.fillStyle = polygon.props.fillColor || _this.props.defaultColor || DEFAULT_DRAW_SETTINGS.DEFAULT_FILL_STYLE;
      ctx.globalAlpha = _this.props.isSidebar ? 1 : polygon.props.fillOpacity || DEFAULT_DRAW_SETTINGS.POLYGONS_OPACITY;
    });
    _defineProperty(_assertThisInitialized(_this), "applyStrokeCtxSettings", function (ctx, polygon) {
      ctx.strokeStyle = polygon.props.strokeColor || ctx.strokeStyle;
      ctx.lineWidth = polygon.props.strokeWidth || ctx.lineWidth;
      ctx.globalAlpha = polygon.props.strokeOpacity || ctx.globalAlpha;
      ctx.lineCap = polygon.props.lineCap || ctx.lineCap;
    });
    _defineProperty(_assertThisInitialized(_this), "drawBackground", function (drawingParams) {
      if (_this.props.background) {
        if (!_this.state.isBackgroundLoaded) {
          var img = new Image();
          img.onload = function () {
            return _this.onImageLoaded(img);
          };
          img.src = _this.props.background;
        } else {
          _this.drawImage(drawingParams);
          _this.drawPolygons(drawingParams);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onImageLoaded", function (img) {
      var _this$props = _this.props,
        container = _this$props.container,
        onBackgroundLoaded = _this$props.onBackgroundLoaded;
      _this.img = img;
      if (onBackgroundLoaded) {
        onBackgroundLoaded([img.width, img.height]);
      }
      _this.setState(function (state) {
        return {
          height: container ? container.offsetHeight : state.height,
          isBackgroundLoaded: true,
          width: container ? container.offsetWidth : state.width
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "drawImage", function (imageDrawParams) {
      _this.ctx.globalAlpha = 1;
      if (imageDrawParams) {
        _this.ctx.drawImage(_this.img, 0, 0, imageDrawParams.drawnImageWidth, imageDrawParams.drawnImageHeight, imageDrawParams.offsetLeft, imageDrawParams.offsetTop, imageDrawParams.imageContainerWidth, imageDrawParams.imageContainerHeight);
      } else {
        _this.ctx.drawImage(_this.img, 0, 0);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getCanvasPosition", function () {
      if (_this.containerElement) {
        var boundingClientRect = _this.containerElement.getBoundingClientRect();
        return [boundingClientRect.left, boundingClientRect.top];
      }
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      if (_this.props.container) {
        _this.setState({
          height: _this.props.container.offsetHeight,
          width: _this.props.container.offsetWidth
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getHoveredPolygonId", function (originAbsolutePoint) {
      var polygons = _this.props.polygons;
      var hoveredPolygonId = null;
      polygons.some(function (polygon) {
        if (pnpoly(polygon.points.length - 1, polygon.points.map(function (point) {
          return point[1];
        }), polygon.points.map(function (point) {
          return point[0];
        }), originAbsolutePoint[0], originAbsolutePoint[1])) {
          hoveredPolygonId = polygon.id;
          return true;
        }
        return false;
      });
      return hoveredPolygonId;
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var onPolygonClick = _this.props.onPolygonClick;
      var hoveredPolygonId = _this.state.hoveredPolygonId;
      if (hoveredPolygonId && onPolygonClick) {
        onPolygonClick(hoveredPolygonId);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (event) {
      var _this$props2 = _this.props,
        drawParams = _this$props2.drawParams,
        onPolygonHover = _this$props2.onPolygonHover,
        background = _this$props2.background;
      if (!drawParams || background && !_this.state.isBackgroundLoaded) {
        return;
      }
      var padding = drawParams.padding,
        scale = drawParams.scale;
      var clientX = event.clientX,
        clientY = event.clientY;
      var canvasPosition = _this.getCanvasPosition() || [0, 0];
      var hoveredPolygonId = _this.getHoveredPolygonId([(clientX - canvasPosition[0] - padding[0]) * scale, (clientY - canvasPosition[1] - padding[1]) * scale]);
      if (_this.state.hoveredPolygonId !== hoveredPolygonId) {
        _this.setState({
          hoveredPolygonId: hoveredPolygonId,
          tooltipPosition: undefined
        });
        if (onPolygonHover) {
          onPolygonHover(hoveredPolygonId || undefined);
        }
      }
      if (hoveredPolygonId) {
        _this.setState({
          tooltipPosition: {
            left: clientX - canvasPosition[0],
            top: clientY - canvasPosition[1]
          }
        });
      }
    });
    _this.state = {
      height: props.container && props.container.offsetHeight || props.height || DEFAULT_CANVAS_SIZE.HEIGHT,
      hoveredPolygonId: null,
      isBackgroundLoaded: false,
      width: props.container && props.container.offsetWidth || props.width || DEFAULT_CANVAS_SIZE.WIDTH
    };
    return _this;
  }
  _createClass(PolygonsDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.canvas) {
        this.ctx = this.canvas.getContext('2d');
        this.draw();
      }
      if (window) {
        window.addEventListener('resize', this.onResize);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.background !== nextProps.background) {
        this.setState({
          isBackgroundLoaded: false
        });
      }
      if (this.props.isFullScreen !== nextProps.isFullScreen) {
        this.onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window) {
        window.removeEventListener('resize', this.onResize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.draw();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = this.props,
        state = this.state;
      var isCanvasVisible = props.background && state.isBackgroundLoaded || !props.background;
      var hoveredPolygon = state.hoveredPolygonId && props.polygons.find(function (polygon) {
        return polygon.id === state.hoveredPolygonId;
      });
      return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, mergeStyles(styles['container'], props.containerStyle)), {}, {
        ref: function ref(container) {
          return _this2.containerElement = container;
        },
        onMouseMove: this.onMouseMove,
        onClick: this.onClick,
        children: [/*#__PURE__*/_jsx("canvas", {
          ref: function ref(canvas) {
            return _this2.canvas = canvas;
          },
          className: isCanvasVisible ? '' : styles['hidden'],
          width: props.autoResize ? state.width : props.width,
          height: props.autoResize ? state.height : props.height
        }), !isCanvasVisible && /*#__PURE__*/_jsx("div", {
          className: styles['preloader-container'],
          children: /*#__PURE__*/_jsx(Preloader, {})
        }), hoveredPolygon && hoveredPolygon.tooltipContent && state.tooltipPosition && /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['tooltip'], {
          left: state.tooltipPosition.left - 24,
          top: state.tooltipPosition.top - 60
        })), {}, {
          children: hoveredPolygon.tooltipContent
        }))]
      }));
    }
  }]);
  return PolygonsDrawer;
}(React.Component);
_defineProperty(PolygonsDrawer, "defaultProps", {
  autoResize: true
});